import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import Booking from 'pages/lexusOfficialAccount/pnp/Booking';
import BookingCancel from 'pages/lexusOfficialAccount/pnp/BookingCancel';
import Event from 'pages/lexusOfficialAccount/pnp/Event';
import TestDrive from 'pages/lexusOfficialAccount/pnp/TestDrive';
import DownloadCalendar from 'pages/lexusOfficialAccount/pnp/DownloadCalendar';
import Error404 from 'pages/errorPages/Error404';

const PnpWebviewRouter = () => {
  useEffect(() => {
    document.title = `LEXUS`;
  }, []);

  return (
    <Routes>
      <Route path="/booking" element={<Booking />}></Route>
      <Route path="/bookingCancel" element={<BookingCancel />}></Route>
      <Route path="/event" element={<Event />}></Route>
      <Route path="/testDrive" element={<TestDrive />}></Route>
      <Route path="/downloadCalendar" element={<DownloadCalendar />}></Route>
      <Route path="*" element={<Error404 />}></Route>
    </Routes>
  );
};

export default PnpWebviewRouter;
